import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

/**
 * Component used with a FilterTable
 * Dropdown with values from a specific column
 * Updates searchParams to be used for fetching data from the API
 * Optionally allows for display values to be different from the actual values (for translations)
 */
export const ColumnLevelFilter = (props) => {
    const { label, columnValues, columnDisplayValues, columnName, searchParams, setSearchParams, maxHeight, InputLabelStyle } =
        props;

    const handleChange = (event) => {
        const newSearchParams = new URLSearchParams(searchParams.toString());
        if (event.target.value) {
            newSearchParams.set(columnName, event.target.value);
        } else {
            // None - remove the filter
            newSearchParams.delete(columnName);
        }
        setSearchParams(newSearchParams);
    };

    return (
        <FormControl variant="outlined" fullWidth>
            <InputLabel style={InputLabelStyle}>{label}</InputLabel>
            <Select
                label={label}
                value={searchParams.get(columnName) || ""}
                onChange={handleChange}
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    margin: 0,
                    maxHeight: maxHeight
                }}
            >
                <MenuItem value="">-</MenuItem>
                {columnValues.map((value, idx) => (
                    <MenuItem key={value} value={value}>
                        {columnDisplayValues?.[idx] ? columnDisplayValues[idx] : value}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
